
<template>
  <div class="card">
        <div class="card-header text-black p-2">
            <div class="d-flex align-items-center gap-3 date-range">
                <div class="d-flex gap-1 align-items-center">
                    <!-- <span class="cursor-pointer text-theme" @click="getPreviousDate">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-square-arrow-left-icon lucide-square-arrow-left"><rect width="18" height="18" x="3" y="3" rx="2"/><path d="m12 8-4 4 4 4"/><path d="M16 12H8"/></svg>
                    </span>
                    <span class="cursor-pointer text-theme" @click="getNextDate">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-square-arrow-right-icon lucide-square-arrow-right"><rect width="18" height="18" x="3" y="3" rx="2"/><path d="M8 12h8"/><path d="m12 16 4-4-4-4"/></svg>
                    </span> -->
                    <PreviousDateIcon v-model="currentDate" />
                    <NextDateIcon v-model="currentDate" />
                    <CalendarIcon v-model="currentDate" :auto-apply="true" />
                </div>
                <div>
                    Available Handyman({{ this.$dateTimeFormat(currentDate, 'ddd, D MMM, YYYY')}})
                    <button
                        v-if="location == 'taskDashboard'"
                        class="btn btn-sm btn-outline-theme ms-2"
                        @click="$emit('switch-to-view', 'old_view')"
                    >Switch to Old View</button>
                </div>
            </div>
        </div>

        <div class="card-body p-2 position-relative">
            <div class="table-responsive">
                <table class="table hm-fs-12 mb-0 align-middle time-block-table table-hover table-sm">
                    <thead>
                        <tr>
                            <th class="bg-theme">Name</th>
                            <th v-for="hour in workingHours" :key="hour.value" class="text-center bg-theme time-block" colspan="4">
                                {{ hour.shortDisplay }}{{ hour.ampm }}
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-if="processing">
                            <td colspan="100" class="text-center">Loading...</td>
                        </tr>
                        <tr v-else-if="handymans.length === 0">
                            <td colspan="100" class="text-center">No handyman available</td>
                        </tr>
                        <tr
                            v-else
                            v-for="(handyman, handymanIndex) in handymans"
                            :key="handymanIndex"
                            class="handyman-row"
                        >
                            <td class="name-column text-capitalize">{{ formatName(handyman.name) }}</td>
                            <!-- If handyman is unavailable -->
                            <template v-if="handyman.is_on_leave">
                                <td
                                    :colspan="workingHours.length*4"
                                    class="text-center on-leave fw-bold"
                                >On Leave</td>
                            </template>
                            <template v-else>
                                <template v-for="(hour, hourIndex) in workingHours" :key="`${handyman.id}-${hour.value}`">
                                    <!-- Create 4 cells for each hour (15-minute segments) -->
                                    <td v-for="segment in [0, 15, 30, 45]" :key="`${handyman.id}-${hour.value}-${segment}`"
                                        class="p-0 position-relative time-segment"
                                        :class="{
                                            'no-right-border': segment < 45 || hourIndex < workingHours.length - 1,
                                            'drag-over': isDragOver && currentDragOverCell === `${handyman.id}-${hour.value}-${segment}`
                                        }"
                                        @dragover="handleDragOver($event, handyman, hour.value, segment)"
                                        @dragleave.prevent="handleDragLeave($event)"
                                        @drop="handleDrop($event, handyman, getSegmentTime(hour.value, segment))"
                                    >

                                        <!-- Background for each 15-minute segment -->
                                        <div class="h-100 w-100 bg-secondary-subtle"></div>

                                        <!-- Available time slots -->
                                        <div
                                            v-if="isTimeAvailable(handyman, getSegmentTime(hour.value, segment))"
                                            class="position-absolute top-0 h-100 bg-success-subtle"
                                            :style="getAvailableTimeStyle(handyman, getSegmentTime(hour.value, segment))"
                                        ></div>

                                        <!-- Bookings that start in this segment -->
                                        <!-- <div
                                            v-for="(booking, bookingIndex) in getBookingsInSegment(handyman, getSegmentTime(hour.value, segment))"
                                            :key="`booking-${handymanIndex}-${bookingIndex}-${hour.value}-${segment}`"
                                            class="position-absolute top-0 h-100 d-flex align-items-center justify-content-center booking-block"
                                            :class="(booking.type === 'order' ? (isProvisionalOrder(booking) ? 'bg-warning-subtle' : 'bg-danger') : 'bg-info-subtle')"
                                            :style="getBookingStyle(booking, getSegmentTime(hour.value, segment))"
                                            :draggable="booking.type === 'order'"
                                            @dragstart="handleDragStart($event, booking, handyman)"
                                            data-bs-toggle="popover"
                                            data-bs-trigger="click"
                                            data-bs-placement="top"
                                            :data-bs-content="preparePopoverContent(handyman, booking)"
                                            data-bs-html="true"
                                            tabindex="0"
                                            @contextmenu.prevent.stop="handleRightClick($event, booking)"
                                        >
                                            {{ booking.type === 'order' ? 'O:' + booking.postal_code : 'P:' + booking.postal_code }}
                                        </div> -->
                                        <div
                                            v-for="(booking, bookingIndex) in getBookingsInSegment(handyman, getSegmentTime(hour.value, segment))"
                                            :key="`booking-${handymanIndex}-${bookingIndex}-${hour.value}-${segment}`"
                                            class="position-absolute top-0 h-100 d-flex align-items-center justify-content-center booking-block"
                                            :class="(booking.type === 'order' ? (isProvisionalOrder(booking) ? 'bg-warning-subtle' : 'booked-slot') : 'bg-info-subtle')"
                                            :style="getBookingStyle(booking, getSegmentTime(hour.value, segment))"
                                            :draggable="booking.type === 'order'"
                                            tabindex="0"
                                            v-popover="preparePopoverComponent(handyman, booking)"
                                            data-bs-html="true"
                                            data-bs-trigger="click"
                                            @dragstart="handleDragStart($event, booking, handyman)"
                                            @contextmenu.prevent.stop="handleRightClick($event, booking)"
                                        >
                                            <div class="d-flex flex-column text-center">
                                                {{ booking.type === 'order' ? 'O: ' + booking.postal_code : 'P: ' + booking.postal_code }}
                                                <small class="text-sm d-block text-capitalize">
                                                    {{ booking.status.toLowerCase() === 'engineer_completed' ? 'E.Completed' : booking.status }}
                                                </small>
                                            </div>
                                        </div>
                                    </td>
                                </template>
                            </template>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <!-- Confirmation Modal -->
        <div class="modal fade" id="confirmRescheduleModal" tabindex="-1" aria-hidden="true">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Confirm Reschedule</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body g-3 profile">
                        <p>
                            Are you sure you want to reschedule this booking?<br/>
                            This change will apply to all handymen on this order.
                        </p>
                        <div v-if="draggedBooking">
                            <div class="row">
                                <div class="col-md-4">
                                    <label class="form-label">Order</label>
                                    <span class="float-end">:</span>
                                </div>
                                <div class="col-md-8 ps-0">
                                    {{ draggedBooking.type === 'order' ? draggedBooking.order_number : draggedBooking.project_name }}
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-4">
                                    <label class="form-label">Old Service Time</label>
                                    <span class="float-end">:</span>
                                </div>
                                <div class="col-md-8 ps-0">
                                    {{ draggedBooking.service_time }}
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-4">
                                    <label class="form-label">New Service Time</label>
                                    <span class="float-end">:</span>
                                </div>
                                <div class="col-md-8 ps-0">
                                    {{ formatTime(newBookingTime) }} - {{ formatTime(calculateEndTime(newBookingTime, draggedBooking)) }}
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-4">
                                    <label class="form-label">Old Handyman</label>
                                    <span class="float-end">:</span>
                                </div>
                                <div class="col-md-8 ps-0">
                                    {{ draggedBooking.handyman_name }}
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-4">
                                    <label class="form-label">New Handyman</label>
                                    <span class="float-end">:</span>
                                </div>
                                <div class="col-md-8 ps-0">
                                    {{ newHandyman ? newHandyman.name : draggedBooking.handyman_name }}
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-4">
                                    <label class="form-label">Postal Code</label>
                                    <span class="float-end">:</span>
                                </div>
                                <div class="col-md-8 ps-0">
                                    {{ draggedBooking.postal_code }}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
                        <button type="button" class="btn btn-theme" @click="confirmReschedule">Confirm</button>
                    </div>
                </div>
            </div>
        </div>

        <!-- Customer Details Modal -->
        <CustomerDetails
            v-if="Object.keys(order).length > 0"
            :order="order"
        />

        <!-- Add Attachment Modal -->
        <AddAttachment
            v-if="Object.keys(order).length > 0"
            :orderId="order.id"
        />

        <!-- Move To Pending Modal -->
        <MoveToPending
            v-if="Object.keys(order).length > 0"
            :order="order"
            @order-updated="getHandymanList"
        />

        <!-- Move To Processing Modal -->
        <MoveToProcessing
            v-if="Object.keys(order).length > 0"
            :order="order"
            @order-updated="getHandymanList"
        />

        <!-- Cancel Order Modal -->
        <CancelOrder
            v-if="Object.keys(order).length > 0"
            :order="order"
            @order-updated="getHandymanList"
        />

        <!-- Assign Order Modal -->
        <AssignOrder
            v-if="Object.keys(order).length > 0"
            :order="order"
            :action="'reassign'"
            @order-updated="getHandymanList"
        />
    </div>
    <!-- right click context -->
    <vue-simple-context-menu
        element-id="handleRightClick"
        :options="rightClickOptions(selectedBooking)"
        ref="rightClickMenu"
        @option-clicked="handleRightClickMenuAction"
    >
    </vue-simple-context-menu>
</template>

<script>
// Import directives
import { tooltipDirective } from '../../directives/tooltip';
import { popoverDirective } from '../../directives/popover';
import { appMixin } from '../../mixin/appMixin';

import VueSimpleContextMenu from "vue-simple-context-menu";
import CalendarIcon from '../partials/CalendarIcon';
import CustomerDetails from '../Order/CustomerDetails';
import AddAttachment from '../Order/AddAttachment';
import MoveToPending from '../Order/MoveToPending';
import MoveToProcessing from '../Order/MoveToProcessing';
import AssignOrder from '../Order/AssignOrder.vue';
import CancelOrder from '../Order/CancelOrder.vue';
import NextDateIcon from '../partials/NextDateIcon.vue';
import PreviousDateIcon from '../partials/PreviousDateIcon.vue';
import PopoverContent from './PopoverContent.vue';

export default {
    directives: {
        tooltip: tooltipDirective,
        popover: popoverDirective
    },
    components: {
        VueSimpleContextMenu,
        CalendarIcon,
        CustomerDetails,
        AddAttachment,
        MoveToPending,
        MoveToProcessing,
        AssignOrder,
        CancelOrder,
        NextDateIcon,
        PreviousDateIcon,
        PopoverContent
    },
    mixins: [appMixin],
    props: {
        location: {
            type: String,
            default: null
        }
    },
    data() {
        return {
            isDragOver: false,
            currentDragOverCell: null,
            currentDate: this.$moment().format('YYYY-MM-DD'),
            handymans: [],
            processing: true,
            nameColumnWidth: 150,
            isDragging: false,
            draggedBooking: null,
            sourceHandyman: null,
            newBookingTime: null,
            newHandyman: null,
            selectedBooking: null,
            // rightClickOptions: [
            //     {name: 'Move to Processing', action: 'move_to_processing'},
            //     {name: 'Move to Pending', action: 'move_to_pending'},
            //     {name: 'View Detail', action: 'view_order_detail'},
            //     {name: 'View Customer', action: 'view_customer'},
            //     {name: 'Add Attachment', action: 'add_attachment'},
            //     {name: 'Reassign Order', action: 'reassign_order'},
            //     {name: 'Cancel Order', action: 'cancel_order'},
            // ],
            order: {}
        }
    },
    computed: {
        systemSettings() {
            return this.$store.getters.getSystemSettings;
        },
        workingHours() {
            // const start = this.$moment(this.systemSettings.hm_working_hours_start ?? '07:00', 'HH:mm');
            // const end = this.$moment(this.systemSettings.hm_working_hours_end ?? '17:00', 'HH:mm');
            const start = this.momentObj(this.settings.hm_working_hours_start, 'HH:mm'); // 07:00
            const end = this.momentObj(this.settings.hm_working_hours_end, 'HH:mm').subtract(1, 'hour'); // 17:00

            const times = [];
            let currentTime = start.clone();
            while (currentTime <= end) {
                times.push({
                    display: currentTime.format('hA'),
                    shortDisplay: currentTime.format('h'),
                    ampm: currentTime.format('A'),
                    value: currentTime.format('HH:mm')
                });
                currentTime.add(1, 'hour');
            }
            return times;
        },
        dayStart() {
            return this.timeToDecimal(this.workingHours[0].value);
        },
        rightClickOptions() {
            return (booking) => {
                // Check if booking is null
                if (!booking) {
                    return [];
                }

                // Check if booking.type == project then display only view detail
                if (booking &&booking.type == 'project') {
                    return [
                        {name: 'View Detail', action: 'view_order_detail'},
                    ];
                }

                // Option for order
                let options = [
                    {name: 'View Detail', action: 'view_order_detail'},
                    {name: 'View Customer', action: 'view_customer'},
                    {name: 'Add Attachment', action: 'add_attachment'},
                    {name: 'Cancel Order', action: 'cancel_order'},
                ];

                //If order status is assigned then add options
                // Move to Processing, Move to Pending and Reassign Order at the top
                if(booking && booking.status === 'assigned') {
                    options.unshift({name: 'Reassign Order', action: 'reassign_order'});
                    options.unshift({name: 'Move to Pending', action: 'move_to_pending'});
                    options.unshift({name: 'Move to Processing', action: 'move_to_processing'});
                }
                else if(booking && booking.status === 'processing') {
                    options.unshift({name: 'Reassign Order', action: 'reassign_order'});
                    options.unshift({name: 'Move to Pending', action: 'move_to_pending'});
                }
                else if(booking && ['declined', 'completed', 'cancelled', 'canceled'].includes(booking.status)) {
                    // Remove the cancel order option
                    options = options.filter(option => option.action !== 'cancel_order');
                }
                return options;
            }
        }
    },
    mounted() {
        this.getHandymanList();

        this.$emitter.on('refresh-order-list', (data) => {
            this.getHandymanList();
        });
    },
    watch: {
        handymans: {
            handler() {
                this.$nextTick(() => {
                    // Popovers are now handled by the directive
                });
            },
            deep: true
        },
        currentDate() {
            this.getHandymanList();
        },
    },
    methods: {
        getHandymanList() {
            this.processing = true;
            axios.post('/admin/dashboard/stats?action=available_handyman', {
                action: 'available_handyman',
                location: this.location,
                date: this.dataTimeFormatWithoutUTC(this.currentDate, 'YYYY-MM-DD')
            })
            .then(response => {
                // Process the data to ensure each booking has type and postal_code
                this.handymans = response.data.map(handyman => {
                if (handyman.bookings) {
                    handyman.bookings = handyman.bookings.map(booking => {
                    // Set default type if not present
                    if (!booking.type) {
                        booking.type = booking.order_id ? 'order' : 'project';
                    }

                    // Ensure postal_code is available
                    if (!booking.postal_code) {
                        if (booking.type === 'order' && booking.address) {
                        booking.postal_code = booking.address.postal_code || 'N/A';
                        } else if (booking.type === 'project') {
                        booking.postal_code = booking.project_customer_postal_code || 'N/A';
                        } else {
                        booking.postal_code = 'N/A';
                        }
                    }

                    // Ensure each booking has a unique ID
                    if (!booking.id) {
                        booking.id = booking.type === 'order'
                        ? `order-${booking.order_id}`
                        : `project-${booking.project_id}`;
                    }

                    return booking;
                    });
                }
                return handyman;
                });

                this.processing = false;
            })
            .catch(error => {
                console.error('Error fetching handyman data:', error);
                this.processing = false;
            });
        },

        getPreviousDate() {
            this.currentDate = this.$moment(this.currentDate).subtract(1, 'days').format('YYYY-MM-DD');
            this.getHandymanList();
        },

        getNextDate() {
            this.currentDate = this.$moment(this.currentDate).add(1, 'days').format('YYYY-MM-DD');
            this.getHandymanList();
        },

        // Get time for a specific 15-minute segment
        getSegmentTime(hourStr, minutes) {
            const [hour] = hourStr.split(':').map(Number);
            return `${hour.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
        },

        // Convert time string to decimal hours for calculations
        timeToDecimal(timeStr) {
            const [hours, minutes] = timeStr.split(':').map(Number);
            return hours + (minutes / 60);
        },

        // Format time for display
        formatTime(timeStr) {
            if (!timeStr) return '';
            return this.$moment(timeStr, 'HH:mm').format('h:mm A');
        },

        // Calculate end time based on start time and booking duration
        calculateEndTime(startTimeStr, booking) {
            if (!startTimeStr || !booking) return '';

            const startTime = this.$moment(startTimeStr, 'HH:mm');
            const bookingStart = this.$moment(booking.start, 'HH:mm');
            const bookingEnd = this.$moment(booking.end, 'HH:mm');

            // Calculate duration in minutes
            const durationMinutes = bookingEnd.diff(bookingStart, 'minutes');

            // Add duration to new start time
            const endTime = startTime.clone().add(durationMinutes, 'minutes');

            return endTime.format('HH:mm');
        },

        // Check if a specific time segment is within handyman's available time
        isTimeAvailable(handyman, timeStr) {
            if (handyman.status === 'unavailable') return false;

            const time = this.timeToDecimal(timeStr);
            const workStart = this.timeToDecimal(handyman.workingHours.start);
            const workEnd = this.timeToDecimal(handyman.workingHours.end);

            return time >= workStart && time < workEnd;
        },

        // Get style for available time slot
        getAvailableTimeStyle(handyman, timeStr) {
            const time = this.timeToDecimal(timeStr);
            const workStart = this.timeToDecimal(handyman.workingHours.start);
            const workEnd = this.timeToDecimal(handyman.workingHours.end);

            // Calculate position and width for partial time segments
            let left = 0;
            let width = 100;

            if (time < workStart && time + 0.25 > workStart) {
                // Start of availability within this segment
                left = (workStart - time) * 400; // 400 = 100% / 0.25 hours
                width = 100 - left;
            }

            if (time < workEnd && time + 0.25 > workEnd) {
                // End of availability within this segment
                width = (workEnd - time) * 400; // 400 = 100% / 0.25 hours
            }

            return {
                left: `${left}%`,
                width: `${width}%`
            };
        },

        // Get bookings that start in a specific 15-minute segment
        getBookingsInSegment(handyman, timeStr) {
            if (!handyman.bookings) return [];

            const time = this.timeToDecimal(timeStr);
            const nextTime = time + 0.25; // 15 minutes = 0.25 hours

            return handyman.bookings.filter(booking => {
                const bookingStart = this.timeToDecimal(booking.start);
                return bookingStart >= time && bookingStart < nextTime;
            });
        },

        // Check if a booking starts in a specific 15-minute segment
        isBookingInSegment(booking, timeStr) {
            const bookingStart = this.timeToDecimal(booking.start);
            const segmentTime = this.timeToDecimal(timeStr);
            const nextSegmentTime = segmentTime + 0.25; // 15 minutes = 0.25 hours

            return bookingStart >= segmentTime && bookingStart < nextSegmentTime;
        },

        // Get style for booking display
        getBookingStyle(booking, timeStr) {
            const bookingStart = this.timeToDecimal(booking.start);
            const bookingEnd = this.timeToDecimal(booking.end);
            const segmentTime = this.timeToDecimal(timeStr);

            // Calculate left offset within the segment (for partial starts)
            const startOffset = (bookingStart - segmentTime) * 400; // 400 = 100% / 0.25 hours

            // Calculate the total duration in hours
            const duration = bookingEnd - bookingStart;

            // Calculate width based on duration (4 segments = 1 hour)
            const borderWidth = booking.type === 'order' ? 10 : 2.8;
            const width = duration * (400 + duration*borderWidth); // 400 = 100% / 0.25 hours

            return {
                left: `${startOffset}%`,
                width: `${width}%`,
                zIndex: 10
            };
        },

        // Drag and drop handlers
        handleDragStart(event, booking, handyman) {
            this.isDragging = true;
            this.draggedBooking = { ...booking };
            this.sourceHandyman = handyman;

            // Set data for drag operation
            event.dataTransfer.setData('text/plain', JSON.stringify({
                bookingId: booking.id,
                handymanId: handyman.id
            }));

            // Set drag image and effect
            event.dataTransfer.effectAllowed = 'move';
        },

        handleDragOver(event, handyman, hourValue, segment) {
            // Only allow drag over if:
            // 1. We have a source handyman (drag is in progress)
            // 2. The handyman is the same as the source handyman
            // 3. The time slot is available
            /* if (this.sourceHandyman &&
                handyman.id === this.sourceHandyman.id &&
                this.isTimeAvailable(handyman, this.getSegmentTime(hourValue, segment))) {
                // Allow drop by preventing default
                event.preventDefault();
                this.isDragOver = true;
                this.currentDragOverCell = `${handyman.id}-${hourValue}-${segment}`;
                event.dataTransfer.dropEffect = 'move';
            } else {
                // Not a valid drop target - don't prevent default
                event.dataTransfer.dropEffect = 'none';
            } */

            const timeStr = this.getSegmentTime(hourValue, segment);
            // Allow drag over if the time slot is available
            if (this.sourceHandyman && this.isTimeAvailable(handyman, timeStr)) {
                // Allow drop by preventing default
                event.preventDefault();
                this.isDragOver = true;
                this.currentDragOverCell = `${handyman.id}-${hourValue}-${segment}`;
                event.dataTransfer.dropEffect = 'move';
            } else {
                // Not a valid drop target - don't prevent default
                event.dataTransfer.dropEffect = 'none';
            }

        },

        handleDragLeave(event) {
            // Only clear if we're actually leaving this cell (not entering a child element)
            if (!event.currentTarget.contains(event.relatedTarget)) {
                this.isDragOver = false;
                this.currentDragOverCell = null;
            }
        },

        handleDrop(event, handyman, timeStr) {
            /* event.preventDefault();
            this.isDragOver = false;
            this.currentDragOverCell = null;

            if (!this.draggedBooking) return;

            // Check if the handyman is the same as the source handyman
            if (handyman.id !== this.sourceHandyman.id) {
                this.$notification('error', 'Cannot move booking to a different handyman');
                return;
            }

            // Check if the time slot is available
            if (!this.isTimeAvailable(handyman, timeStr)) {
                this.$notification('error', 'Cannot reschedule to unavailable time slot');
                return;
            }

            // Set new booking time
            this.newBookingTime = timeStr;
            this.newHandyman = null; // Always null since we're only allowing same handyman

            // Show confirmation modal
            $('#confirmRescheduleModal').modal('show'); */

            event.preventDefault();
            this.isDragOver = false;
            this.currentDragOverCell = null;

            if (!this.draggedBooking) return;

            // Check if the time slot is available
            if (!this.isTimeAvailable(handyman, timeStr)) {
                this.$notification('error', 'Cannot reschedule to unavailable time slot');
                return;
            }

            // Set new booking time and handyman
            this.newBookingTime = timeStr;
            this.newHandyman = handyman.id !== this.sourceHandyman.id ? handyman : null;

            // Show confirmation modal
            $('#confirmRescheduleModal').modal('show');
        },

        confirmReschedule() {
            if (!this.draggedBooking || !this.newBookingTime) {
                $('#confirmRescheduleModal').modal('hide');
                return;
            }

            // Calculate new end time
            const newEndTime = this.calculateEndTime(this.newBookingTime, this.draggedBooking);

            // Prepare data for API call
            /* const bookingData = {
                oh_id: this.draggedBooking.oh_id,
                order_id: this.draggedBooking.order_id,
                type: this.draggedBooking.type,
                date: this.currentDate,
                start_time: this.newBookingTime,
                end_time: newEndTime,
                handyman_id: this.sourceHandyman.id,  // Add the handyman ID
                service_duration: this.draggedBooking.oh_service_hours
            }; */

            // Prepare data for API call
            const bookingData = {
                oh_id: this.draggedBooking.oh_id,
                order_id: this.draggedBooking.order_id,
                type: this.draggedBooking.type,
                date: this.currentDate,
                start_time: this.newBookingTime,
                end_time: newEndTime,
                service_duration: this.draggedBooking.oh_service_hours,
                handyman_id: null,  // Use the target handyman's ID
                handyman_name: null,
                previous_handyman_name: this.sourceHandyman.name,
                previous_handyman_id: this.sourceHandyman.id  // Track the original handyman
            };

            // If handyman is changed, add handyman data
            if (this.newHandyman) {
                bookingData.handyman_id = this.newHandyman.id;
                bookingData.handyman_name = this.newHandyman.name;
            }

            // Determine the API endpoint based on booking type
            const endpoint = this.draggedBooking.type === 'order'
                ? '/api/admin/reschedule-booking'
                : '/admin/projects/update-booking-time';

            // Call API to update booking
            axios.post(endpoint, bookingData)
                .then(response => {
                    this.$notification(response.data.status, response.data.message);
                    if(response.data.status === 'error') {
                        return;
                    }
                    this.getHandymanList(); // Refresh data

                    // Emit an event for refreshing the order list
                    this.$emitter.emit('scheduleTimeChanged', {});
                })
                .catch(error => {
                    console.error('Error rescheduling booking:', error);
                    this.$notification('error', 'Failed to reschedule booking');
                })
                .finally(() => {
                    // Close modal and reset drag state
                    $('#confirmRescheduleModal').modal('hide');
                    this.resetDragState();
                });
        },

        resetDragState() {
            this.isDragging = false;
            this.isDragOver = false;
            this.currentDragOverCell = null;
            this.draggedBooking = null;
            this.sourceHandyman = null;
            this.newBookingTime = null;
            this.newHandyman = null;
        },

        showBookingDetails(booking) {
            // Show booking details in a modal or popover
            if (booking.type === 'order') {
                const details = `
                Order #${booking.order_id}
                Customer: ${booking.customer_name || 'N/A'}
                Address: ${booking.booking_address || 'N/A'}
                Postal Code: ${booking.postal_code || 'N/A'}
                Time: ${booking.start} - ${booking.end}
                `;
                alert(details);
            } else {
                const details = `
                Project: ${booking.project_name || 'N/A'}
                Customer: ${booking.project_customer_name || 'N/A'}
                Address: ${booking.project_address || 'N/A'}
                Postal Code: ${booking.postal_code || 'N/A'}
                Time: ${booking.start} - ${booking.end}
                `;
                alert(details);
            }
        },
        preparePopoverComponent(handyman, booking) {
            if (!booking) return null;
            
            return {
                component: PopoverContent,
                props: {
                    booking: booking,
                    systemSettings: this.systemSettings
                },
                onCopyAddress: this.copyAddress
            };
        },
        copyAddress(address) {
            // Copy address to clipboard
            navigator.clipboard.writeText(address).then(() => {
                this.$notification('success', 'Address copied to clipboard!');
            }).catch(err => {
                console.error('Failed to copy address: ', err);
                this.$notification('error', 'Failed to copy address');
            });
        },
        handleRightClick(event, item) {
            this.selectedBooking = item;
            this.$refs.rightClickMenu.showMenu(event, item)
        },
        handleRightClickMenuAction(event) {
            let booking = event.item;
            let action = event.option.action;

            this.order = {
                id: booking.order_id,
                order_number: booking.order_number,
                order_type: booking.order_type,
                service_duration: booking.oh_service_hours || 1,
                postal_code: booking.postal_code,
                service_address: booking.service_address,
                service_date: booking.service_date,
                service_time: booking.service_time,
                price: booking.total_amount,
                status: booking.status,
                access_arrangement: booking.access_arrangement,
                services: booking.services,
                handymans: booking.handymans || [],
                customer: {
                    id: booking?.customer?.id || '',
                    name: booking?.customer?.name || '',
                    email: booking?.customer?.email || '',
                    phone_number: booking?.customer?.phone_number || '',
                    account_type: booking?.customer?.account_type || '',
                    cp_name: (booking?.address?.contact_persons[0]?.first_name + ' ' + booking?.address?.contact_persons[0]?.last_name || ''),
                    cp_phone: booking?.address?.contact_persons[0]?.phone_number || '',
                    cp_email: booking?.address?.contact_persons[0]?.email || '',
                    cp_type: booking?.address?.contact_persons[0]?.person_type || '',
                    notes: booking?.customer?.notes || '',
                },
                address: {
                    id: booking?.address?.id || '',
                    address: booking?.address?.address || '',
                    address_1: booking?.address?.address_1 || '',
                    address_2: booking?.address?.address_2 || '',
                    city: booking?.address?.city || '',
                    state: booking?.address?.state || '',
                    postal_code: booking?.address?.postal_code || '',
                    country: booking?.address?.country || '',
                    full_address: booking?.address?.full_address || '',
                    notes: booking?.address?.notes || '',
                }
            };

            if (action === 'view_order_detail') {
                // Open in the same tab
                window.location.href = event.item.detail_url;
                return;
                //window.open(event.item.detail_url);
            }
            else if (action === 'view_customer') {
                // Trigger the modal to show after a small delay
                this.$nextTick(() => {
                    $('#viewCustomer').modal('show');
                });
            }
            else if (action === 'add_attachment') {
                // Trigger the modal to show after a small delay
                this.$nextTick(() => {
                    $('#addAttachmentModal').modal('show');
                });
            }
            else if (action === 'move_to_pending') {
                // Trigger the modal to show after a small delay
                this.$nextTick(() => {
                    $('#moveToPendingModal').modal('show');
                });
            }
            else if (action === 'move_to_processing') {
                // Trigger the modal to show after a small delay
                this.$nextTick(() => {
                    $('#moveToProcessingModal').modal('show');
                });
            }
            else if (action === 'reassign_order') {
                // Trigger the modal to show after a small delay
                this.$nextTick(() => {
                    $('#assignOrderModal').modal('show');
                });
            }
            else if (action === 'cancel_order') {
                // Trigger the modal to show after a small delay
                this.$nextTick(() => {
                    $('#cancelOrderModal').modal('show');
                });
            }
        },
        openDatePicker() {
            this.$refs.datePicker.openMenu();
        }
    }
};
</script>

<style scoped>

.name-column {
    width: 100px;
    min-width: 100px;
    max-width: 100px;
}

.time-block-table {
    width: 100%;
}

.time-block-table th,
.time-block-table td {
    border: 1px solid #ccd5dd;
    padding: 0.5rem;
    height: 40px;
}

.time-block {
    width: calc((100% - 150px) / 11); /* Adjust based on number of hours */
    min-width: 60px; /* Minimum width to prevent shrinking */
}

.no-right-border {
    border-right: none !important;
}

.time-slot {
    border: none;
}

.booking-block {
    cursor: pointer;
    font-size: 0.75rem;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

/* .booking-block:hover {
    box-shadow: 0 0 0 2px rgba(0, 0, 0, 0.3);
    z-index: 20 !important;
} */

/* Force table to be full width */
.table-responsive {
    overflow-x: auto;
}

/* Add these new styles for drag and drop visual feedback */
.time-segment.drag-over {
    background-color: rgba(0, 123, 255, 0.2) !important;
    border: 2px dashed #0d6efd !important;
    z-index: 5;
}

/* Add a style for the cell content to ensure it doesn't expand */
.time-segment {
    position: relative;
    width: 15px; /* Fixed width for each 15-minute segment */
    min-width: 15px;
    max-width: 15px;
    padding: 0 !important;
    overflow: visible;
}

.on-leave, .booked-slot {
    background-color: #fdecea;   /* light pastel red */
    color: #b42318;              /* readable dark red text */
    text-align: center;
    border-radius: 4px;
}
</style>
